import React from 'react';
import css from './RuleBooksCards.module.css';
import { FormattedMessage } from 'react-intl';
import { IconCollection } from '../../../components';
import { v4 as uuidv4 } from 'uuid';
import { createResourceLocatorString } from '../../../util/routes';
import { toastifyFn } from '../../../components/ReactToastify/ReactToastify';

const RuleBooksCards = (props) => {

  const {
    rulebooks,
    onAddOrRemoveFavChats,
    favFileIds = [],
    currentUser,
    routeConfiguration,
    history
  } = props;

  return (
    <div className={css.card}>
      <div className={css.cardContent}>
        <div>
          <img src={rulebooks.logo_url} width="126px"
            height="126px" />
        </div>
        <span onClick={() => {
          if (!currentUser?.id?.uuid) {
            return;
          }
          onAddOrRemoveFavChats({ rulebook_id: rulebooks.rulebook_id, user_id: currentUser?.id?.uuid })
        }} className={css.favouriteIcon}>{favFileIds.includes(rulebooks.rulebook_id) ? <IconCollection name="myFavouriteIconFill" /> : <IconCollection name="myFavouriteIconFillBorder" />}</span>
        <p>{rulebooks.rulebook_name}</p>
        <div
          className={css.startChatButton}
          onClick={() => {
            if (!currentUser?.id?.uuid) {
              toastifyFn('info', <FormattedMessage id="RuleBooksCards.loginSigup" />);
              return;
            }

            const url = createResourceLocatorString(
              'AiChatBotRulebookPage',
              routeConfiguration,
              { rulebookId: rulebooks.rulebook_id, sessionId: uuidv4() },
              {}
            );
            history.push(url);
          }}
        >
          <FormattedMessage id="RuleBooksCards.startChat" />
        </div>
      </div>
    </div>

  );
};

export default RuleBooksCards;
